import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs/internal/Subject';
import {map} from 'rxjs/operators';

export interface GetAddressIoAddress {
  'formatted_address': string[];
  'thoroughfare': string;
  'building_name': string;
  'sub_building_name': string;
  'sub_building_number': string;
  'building_number': string;
  'line_1': string;
  'line_2': string;
  'line_3': string;
  'line_4': string;
  'locality': string;
  'town_or_city': string;
  'county': string;
  'district': string;
  'country': string;
  'postcode'?: string;
  'latitude'?: number;
  'longitude'?: number;
}

interface GetAddressIoExpandedResult {
  'postcode': string;
  'latitude': number;
  'longitude': number;
  'addresses': GetAddressIoAddress[];
}

export const apiFindByPostCodeUrl = `https://api.getAddress.io/find`;
export const addressApiKey = 'rq2ptHwF7kSgWAB2R-N5Tw13357';

@Injectable()
export class AddressLookupService {

  // Observable string sources
  public addresses = new Subject<any[]>();

  // Observable string streams
  public addressObservable = this.addresses.asObservable();

  constructor(private httpClient: HttpClient) {
  }

  lookupByPostCode(postCode: string): void {

    postCode = postCode.replace(/ /g, '');

    const url = `${apiFindByPostCodeUrl}/${postCode.trim()}`;
    let lat;
    let lng;
    this.httpClient.get(url,
      {params: {'api-key': addressApiKey, 'sort': 'true', 'expand': 'true'}}
    ).pipe(
      map((result: GetAddressIoExpandedResult) => {
        lat = result.latitude;
        lng = result.longitude;
        return result.addresses;
      })
    ).subscribe((addresses) => {
      const updatedAddresses = addresses.map((address: GetAddressIoAddress) => {
        return {...address, latitude: lat, longitude: lng, postcode: postCode};
      });
      this.updateAddresses(updatedAddresses);
    });
  }

  // Service message commands
  updateAddresses(addresses: any) {
    this.addresses.next(addresses);
  }
}
